const chatAlert = new Audio("audio/chat-alert.mp3");

export const playChatAlert = () => {
  chatAlert.play();
};
